import { KeyboardEvent, MouseEvent, useEffect, useRef } from 'react';
import { AgGridReact } from 'ag-grid-react';
import Actionbar from 'src/components/common/actionbar/Authactionbar';
import { Message } from 'src/components/common/form/Message';
import useUiuxStore from 'src/store/useUiuxStore';
import { Content_MST2020_R01 } from './Content_MST2020_R01';
import { MST2020_R01Dto } from './Dto_MST2020_R01';
import { SearchSection_MST2020_R01 } from './SearchSection_MST2020_R01';
import { useMST2020_R01Store } from './Store_MST2020_R01';
import { Table_MST2020_R01 } from './Table_MST2020_R01';

export const Container_MST2020_R01 = () => {
	const { setMessage } = useUiuxStore();
	const { MST2020_R01List, initData } = useMST2020_R01Store();
	const gridRef = useRef<AgGridReact<MST2020_R01Dto>>(null);

	const {
		clickable,
		setClickable,
		fetchData,
		defaultMST2020_R01Row,
		handleInsertClick,
		handleSaveClick,
		handleDeleteClick,
	} = Content_MST2020_R01({ gridRef, setMessage });

	useEffect(() => {
		if (MST2020_R01List.length === 0) {
			handleInsertClick({} as MouseEvent<HTMLButtonElement>);
		}
	}, [MST2020_R01List, handleInsertClick]);

	return (
		<div className="content-container">
			<Actionbar
				onFetchClick={fetchData}
				onCreateClick={handleInsertClick}
				onDeleteClick={handleDeleteClick}
				onSaveClick={handleSaveClick}
				onInitClick={initData}
			/>
			<SearchSection_MST2020_R01
				onEnterKeyDown={(e: KeyboardEvent<HTMLInputElement>) => {
					if (e.key === 'Enter') fetchData();
				}}
			/>
			<div className="flex-1 flex">
				<div className="w-full h-full flex flex-col p-[12px] gap-[12px]">
					<Table_MST2020_R01
						clickable={clickable}
						setClickable={setClickable}
						gridRef={gridRef}
						defaultMST2020_R01Row={defaultMST2020_R01Row()}
					/>
				</div>
			</div>
			<Message />
		</div>
	);
};
